import React from 'react'
import Graph from '../components/Chart'
import Mode from '../components/Mode';
function Dashboard() {
    return (
      <>
      <Graph></Graph>
      <Mode />
      </>
    );
  }
  
  export default Dashboard;